import { render, staticRenderFns } from "./board-list.vue?vue&type=template&id=46fc9b66&scoped=true&"
import script from "./board-list.vue?vue&type=script&lang=js&"
export * from "./board-list.vue?vue&type=script&lang=js&"
import style0 from "./board-list.vue?vue&type=style&index=0&id=46fc9b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fc9b66",
  null
  
)

export default component.exports